import { createFileRoute } from "@tanstack/react-router"
import { issueTypeDetailViewLayoutHandle } from "src/views/IssueTypeDetailView/constants"
import { IssueTypeDetailView } from "src/views/IssueTypeDetailView/IssueTypeDetailView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/issue-types/$issueTypeId",
)({
	component: IssueTypeDetailView,
	staticData: issueTypeDetailViewLayoutHandle,
})
